// 會員系統連結
import { useSelector } from 'react-redux';
import { urlState } from '@/slices/urlSlice';
import Link from 'next/link';

const UserMemberLink = ({ t, uid }) => {
    const { memberUrl, forumUrl } = useSelector(urlState);

    return (
        <div
            className="my-[16px] space-y-[16px] [&>div]:flex [&>div]:gap-x-[16px] text-btn1 text-black [&>div>*]:w-full [&>div>*]:px-[20px] [&>div>*]:py-[14px]
            [&>div>*]:border-1 [&>div>*]:border-black1 [&>div>*]:rounded-[4px] [&>div>*]:trans [&>div>*]:text-center"
        >
            <div>
                <a
                    href={memberUrl + '/profile'}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="hover:border-bou hover:bg-bou hover:text-white"
                >
                    {t('PROFILE')}
                </a>
                <a
                    href={memberUrl + '/collection'}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="hover:border-bou hover:bg-bou hover:text-white"
                >
                    {t('COLLECT')}
                </a>
            </div>

            <div>
                <a
                    href={memberUrl + '/account-security'}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="hover:border-bou hover:bg-bou hover:text-white"
                >
                    {t('ACCOUNT')}
                </a>
                <Link
                    href={forumUrl + `/user/${uid}/following`}
                    title={t('COMING')}
                    className="hover:border-bou hover:bg-bou hover:text-white"
                >
                    {t('FOLLOWING')}
                </Link>
            </div>

            <div>
                <Link
                    href={forumUrl + `/user/${uid}/followers`}
                    title={t('COMING')}
                    className="hover:border-bou hover:bg-bou hover:text-white"
                >
                    {t('FOLLOWER')}
                </Link>
                <a
                    href={memberUrl + '/profile?preference=true'}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="hover:border-bou hover:bg-bou hover:text-white"
                >
                    {t('READ')}
                </a>
            </div>
        </div>
    );
};

export default UserMemberLink;
